<template>
  <v-dialog
    :value="value"
    max-width="520"
    persistent
    data-testid="bulk-edit-owner-modal"
    @input="$emit('input', $event)"
  >
    <v-card class="bulk-edit-owner-modal">
      <v-card-title class="bulk-edit-owner-modal__header white--text">
        <span>Re-Assign Owners</span>
        <v-spacer />
        <v-btn
          icon
          dark
          data-testid="bulk-edit-owner-modal__close-btn"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="bulk-edit-owner-modal__body pt-6">
        <div
          class="bulk-edit-owner-modal__selected-count d-flex align-center gap-120 mb-6"
          data-testid="bulk-edit-owner-modal__selected-count"
        >
          <h6 class="font-weight-medium bulk-edit-owner-modal__selected-count-label">Selected</h6>
          <h3 class="font-weight-medium">{{ selectedCount }}</h3>
        </div>

        <div class="bulk-edit-owner-modal__field mb-4">
          <label class="bulk-edit-owner-modal__label">Action</label>
          <lb-string value="Replace" label="" disabled data-testid="bulk-edit-owner-modal__action-field" />
        </div>

        <div class="bulk-edit-owner-modal__field">
          <label class="bulk-edit-owner-modal__label">Requested from</label>
          <lb-dropdown
            class="flex-grow-1"
            :items="formattedOwnerList"
            itemtext="displayName"
            itemvalue="_id"
            :value="selectedOwnerId"
            label=""
            placeholder="Information owner"
            :error="error"
            data-testid="bulk-edit-owner-modal__owner-dropdown"
            @input="onOwnerChange"
          />
        </div>
      </v-card-text>

      <v-card-actions class="bulk-edit-owner-modal__footer px-6 pb-6">
        <v-spacer />
        <v-btn
          outlined
          class="bulk-edit-owner-modal__cancel-btn text-capitalize secondaryBtn"
          data-testid="bulk-edit-owner-modal__cancel-btn"
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          class="white--text text-capitalize ml-3"
          :loading="loading"
          :disabled="!selectedOwnerId"
          data-testid="bulk-edit-owner-modal__replace-btn"
          @click="submit"
        >
          Replace
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import './BulkEditOwnerModal.scss';

export default {
  name: 'BulkEditOwnerModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedCount: {
      type: Number,
      default: 0,
    },
    infoOwnerList: {
      type: Array,
      default: () => [],
    },
    error: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedOwnerId: '',
    };
  },
  computed: {
    formattedOwnerList() {
      return (this.infoOwnerList || [])
        .filter((owner) => owner.status !== false)
        .map((owner) => ({
          ...owner,
          displayName: owner.email ? `${owner.name} (${owner.email})` : owner.name,
        }));
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.selectedOwnerId = '';
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    onOwnerChange(value) {
      this.selectedOwnerId = value;
      this.$emit('update:error', '');
    },
    submit() {
      if (!this.selectedOwnerId) return;
      this.$emit('replace', this.selectedOwnerId);
    },
  },
};
</script>
